<template>
  <v-dialog
    v-model="$lojas_formas_pgto.addRules"
    width="800"
    persistent
    class="base rounded-xl"
  >
    <v-row no-gutters class="base rounded-xl d-flex flex-column pa-1">
      <v-row no-gutters class="base rounded-xl mb-4">
        <v-spacer></v-spacer>
        <v-col cols="8">
          <h3 class="text-center">{{ modalTitle }}</h3>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <CloseIcon @action="closeModal" />
        </v-col>
      </v-row>
      <v-form
        @submit.prevent="
          $lojas_formas_pgto.validateRuleRegister(
            storeInfo.idloja,
            $lojas_formas_pgto.ruleForm.idformaPag
          )
        "
        class="px-4"
      >
        <v-row no-gutters class="py-2">
          <v-col cols="6" class="pr-2">
            <label required class="input-labels">Ordem</label>
            <v-text-field
              solo
              placeholder="Insira a ordem"
              type="number"
              class="textinput"
              min="1"
              v-model="$lojas_formas_pgto.ruleForm.order"
              :error-messages="$lojas_formas_pgto.ruleForm.error.order"
              @input="$lojas_formas_pgto.ruleForm.error.order = []"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pl-2">
            <label required class="input-labels">Descrição</label>
            <v-text-field
              solo
              placeholder="Insira uma descrição"
              class="textinput"
              type="text"
              v-model="$lojas_formas_pgto.ruleForm.description"
              :error-messages="$lojas_formas_pgto.ruleForm.error.description"
              @input="$lojas_formas_pgto.ruleForm.error.description = []"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters class="py-2">
          <v-col cols="6" class="pr-2">
            <label required class="input-labels">Adquirente</label>
            <v-autocomplete
              solo
              height="48"
              placeholder="Selecione o adquirente"
              type="text"
              item-text="descricao"
              item-value="id"
              class="textinput"
              v-model="$lojas_formas_pgto.ruleForm.adquirent"
              :filter="search"
              :items="$lojas_formas_pgto.adquirentes"
              :error-messages="$lojas_formas_pgto.paymentForm.error.adquirent"
              @input="$lojas_formas_pgto.paymentForm.error.adquirent = []"
            >
              <template v-slot:selection="{ item }">
                <div v-if="item ? (adquirent = item) : null">
                  {{ adquirent.descricao }}
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="6" class="pl-2">
            <label class="input-labels">Análise de Risco</label>
            <v-select
              solo
              placeholder="Insira uma descrição"
              height="48"
              class="textinput"
              type="text"
              item-text="descricao"
              item-value="id"
              clearable
              :clear-icon="$config.icons.clear"
              :color="this.$vuetify.theme.themes.light.secondary"
              :items="$lojas_formas_pgto.analiseRisco"
              v-model="$lojas_formas_pgto.ruleForm.riskAnalysis"
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters class="justify-end py-4">
          <v-btn
            class="order-2 btn-save"
            dark
            dense
            type="submit"
            :loading="$lojas_formas_pgto.formas_pgto_button_loading"
          >
            Salvar
          </v-btn>
          <v-btn
            class="btn-save"
            color="transparent"
            elevation="0"
            @click="closeModal"
          >
            Cancelar
          </v-btn>
        </v-row>
      </v-form>
    </v-row>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "ModalAddRegra",
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  data() {
    return {
      headersRegras: [
        {
          text: "ID",
          align: "center",
          sortable: false,
          value: "idforma_pag",
        },
        {
          text: "Descrição",
          align: "center",
          sortable: false,
          value: "dscregra",
        },
        {
          text: "Regras",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      rulesDetails: false,
      adquirent: "",
    };
  },
  computed: {
    ...mapGetters(["storeSequencial", "storeInfo"]),
    modalTitle() {
      if (this.$lojas_formas_pgto.ruleActionType === "new") return "Nova Regra";
      else return "Editar Regra";
    },
  },
  methods: {
    closeModal() {
      this.$lojas_formas_pgto.addRules = false;
      this.regras_forma_pag = [];
      this.$lojas_formas_pgto.cleanRule();
    },
    openRegrasDetails(rules) {
      if (rules === null) {
        this.$config.alert(
          "Nenhuma regra cadastrada",
          this.$config.dados.errorColor
        );
        return;
      }
      this.$lojas_formas_pgto.rulesDetails = Object.values(JSON.parse(rules));
      this.$lojas_formas_pgto.rulesDetailsOpen = true;
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    search(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
};
</script>

<style scoped></style>
